import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from '../../../../../styles/fonts';

const useStyles = makeStyles({
  formMessage: {
    fontSize: '14px',
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
    lineHeight: '16px',
  },
  bodyContent: {
    flexGrow: 1,

    '& > div:first-child': {
      paddingBottom: '34px',
    },
    '& > div': {
      paddingBottom: '24px',
    },
    '& > div:last-child': {
      paddingBottom: '0',
    },
  },
  footer: {
    '& > button': {
      marginLeft: '6px',
    },
  },
  root: {
    '& .MuiInputAdornment-positionEnd > button': {
      color: colors.black,
    },
  },
});

export default useStyles;
